export default function CompSaber({setPagina}) {
    return (
      <div className="content contacto">
        <h1>Saber más</h1>
        <button onClick={() => setPagina("inicio")}>Volver</button>

      </div>
    );
  }
  